import { render } from "./topicCard.vue?vue&type=template&id=56f28e6c&scoped=true"
import script from "./topicCard.vue?vue&type=script&lang=js"
export * from "./topicCard.vue?vue&type=script&lang=js"

import "./topicCard.vue?vue&type=style&index=0&id=56f28e6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f28e6c"]])

export default __exports__